export default __webpack_public_path__ + "static/media/square-knife-16.82685f70.svg";